import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, OutlinedInput } from "@mui/material";
import { ChangeEvent, KeyboardEvent } from "react";
import { fieldRootSx } from "./fieldStyles";

export interface SearchInputProps {
  placeholder?: string;
  value?: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  /** Fired when the user presses Enter */
  onSearch?: () => void;
  fullWidth?: boolean;
}

const SearchInput = ({ placeholder, value, onChange, onSearch, fullWidth = true }: SearchInputProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") onSearch?.();
  };
  return (
    <OutlinedInput
      fullWidth={fullWidth}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      sx={fieldRootSx}
      endAdornment={
        <InputAdornment position="end">
          <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
        </InputAdornment>
      }
    />
  );
};

export default SearchInput;
